// 共享菜单数据源：侧边栏(App.vue) 与 系统菜单设置页(Menu.vue) 共用。
// sys_menu 表是唯一数据源；编辑菜单名称后调用 loadMenuTree() 刷新，
// 侧边栏因读取此 observable 而实时更新（无需刷新页面）。
import Vue from 'vue'
import { sysMenuList } from '@/api/sysMenu'

// 前端隐藏的菜单路径（生产库未及时更新 status 时兜底）
const HIDDEN_MENUS = ['/goods/stock', '/member/benefit']

export const menuState = Vue.observable({ tree: [] })

function filterHiddenMenus(list) {
  if (!Array.isArray(list)) return []
  return list
    .filter(m => !HIDDEN_MENUS.includes(m.path))
    .map(m => {
      if (m.children && m.children.length) {
        return { ...m, children: filterHiddenMenus(m.children) }
      }
      return m
    })
}

export async function loadMenuTree() {
  try {
    const res = await sysMenuList()
    const list = (res.data && res.data.data)
      ? res.data.data
      : (Array.isArray(res.data) ? res.data : [])
    menuState.tree = filterHiddenMenus(list || [])
  } catch (e) {
    menuState.tree = []
  }
}
